import React, { useEffect, useState } from 'react';
import {
  CompositeView,
  FilterWidget,
  FormInput,
  FormSelect,
  FormSubmitButton,
  GridView,
  MasterDetailForm,
  SimpleView,
  Table,
  Widget,
} from '@digital/ui';
import { ColumnProps } from 'antd/lib/table';
import { getTipoServicoOptions } from '@app/api/tipoServico';
import { DemandaFiltro, getAllDemandasComFiltro, getDescricoesDocumentoOptions } from '@app/api/demanda';
import ModalListaAnexo from './ModalListaAnexo';

const Acervo = () => {
  const [dados, setDados] = useState([]);
  const [getList, setGetList] = useState<boolean>(true);
  const [filter, setFilter] = useState<DemandaFiltro>({});

  useEffect(() => {
    handleFilter(filter);
  }, [getList]);

  const handleFilter = (values: DemandaFiltro) => {
    getAllDemandasComFiltro(values).then(resp => resp && setDados(resp));
    setFilter(values);
  };

  const columns: ColumnProps<any>[] = [
    {
      title: 'Tipo de Serviço',
      dataIndex: 'tipoServico',
    },
    {
      title: 'Objeto Contrato',
      dataIndex: 'objeto',
    },
    {
      title: 'PTR',
      dataIndex: 'haveraMaoDeObraEmPTR',
      width: '1%',
      render: (text, record) => (record.haveraMaoDeObraEmPTR ? 'Sim' : 'Não'),
    },
    {
      title: 'SLA',
      dataIndex: 'haveraSla',
      width: '1%',
      render: (text, record) => (record.haveraSla ? 'Sim' : 'Não'),
    },
    {
      title: 'Ações',
      width: '1%',
      render: (text, record) => {
        return <ModalListaAnexo demandaId={record.id} />;
      },
    },
  ];

  return (
    <CompositeView>
      <SimpleView>
        <GridView noform>
          <MasterDetailForm onSubmit={handleFilter}>
            <FilterWidget
              title="Filtros"
              actions={[
                <FormSubmitButton type="primary" icon={'commons-search'}>
                  Pesquisar
                </FormSubmitButton>,
              ]}>
              <FormSelect
                id="mrn-select-tipoServico"
                allowClear
                label="Tipo de Serviço"
                name="tipoServicoId"
                span={6}
                getOptions={getTipoServicoOptions}
              />
              <FormSelect
                allowClear
                label="Tipo de Documento"
                name="descricaoDocumento"
                span={6}
                getOptions={getDescricoesDocumentoOptions}
              />
              <FormInput label="Palavras Chave" name="tag" span={12} />
            </FilterWidget>
          </MasterDetailForm>
          <Widget title="Acervo">
            <Table columns={columns} dataSource={dados} />
          </Widget>
        </GridView>
      </SimpleView>
    </CompositeView>
  );
};

export default Acervo;
